// src/pages/Faq.jsx
// import React from "react";
import { HashLink } from 'react-router-hash-link';


function Faq() {
  const faqs = [
    {
    question: "What is this portfolio about?",
    answer:
        "This is my personal portfolio showcasing projects, skills, and experiences in data science, machine learning, artificial intelligence, and software development.",
    },
    {
        question: "Who is this portfolio for?",
        answer:
            "This portfolio is for anyone interested in my work — from collaborators and domain experts to students and tech enthusiasts exploring ML/AI, data science, and product-focused solutions.",
    },
    {
        question: "What’s your current professional role?",
        answer:
            "I currently work as an AI and Data Science Engineer at Deloitte, applying data science and AI in the healthcare domain. Previously, I worked at Capco on data and AI initiatives for global banking clients.",
    },
    {
        question: "What industries have you worked in?",
        answer:
            "I currently work in healthcare, and my previous experience includes BFSI and FinTech. Across these domains, I’ve contributed to data science, machine learning, and AI solutions, including regulatory risk systems, customer behavior analysis, and compliance tools for global banking clients.",
    },
    {
        question: "What’s your strongest technical area?",
        answer:
            "I specialize in end-to-end data science product development — from data engineering to modeling to deployment — with deep expertise in NLP, LLMs, and scalable pipeline design.",
    },
    {
        question: "What tools and technologies do you use?",
        answer:
            "I regularly work with Python, PySpark, SQL, LangChain, Hugging Face, PyTorch, TensorFlow, Docker, and MLOps/deployment stacks. My tech stack adapts to the problem at hand.",
    },
    {
        question: "What kind of projects do you work on?",
        answer:
            "I work on real-world data-driven projects such as predictive modeling, NLP-based applications, computer vision tools, and generative AI integrations.",
    },
    {
        question: "Do you build production-ready solutions?",
        answer:
            "Yes. Many of my projects are full-stack, production-grade systems with clean architecture, performance optimizations, and real-time capabilities.",
    },
    {
        question: "Do you work on real-world data?",
        answer:
            "Yes. My experience includes working with real-world data in healthcare and, previously, in global banking—including customer behavior datasets, regulatory pipelines, and financial models.",
    },
    {
        question: "Do you have experience with Generative AI?",
        answer:
            "Yes. I’ve built generative AI tools using LLMs like LLaMA and Groq, including chatbots, summarization pipelines, and content generation with safety layers.",
    },
    {
        question: "What sets your portfolio apart?",
        answer:
            "Beyond code, it reflects real product thinking — measurable business impact, clean architecture, live demos, and integration of writing, research, and innovation into one cohesive space.",
    },
    {
        question: "Do you have leadership experience?",
        answer:
            "Yes. I’ve led multiple projects end-to-end, mentored junior analysts, enforced coding standards, and played a key role in stakeholder engagement and delivery strategy.",
    },
    {
        question: "Have you received any awards?",
        answer:
            "Yes, I’ve been awarded multiple times for my contributions, performance, and innovation in large-scale client projects.",
    },
    {
        question: "Do you write technical blogs?",
        answer:
            "Yes, I write detailed blogs simplifying complex ML/AI topics and technologies.",
    },
    {
        question: "Are your projects open-source?",
        answer:
            "Most of my exploratory and demo projects are open-source. You can find them in the personal projects section or on my GitHub profile.",
    },
    {
        question: "Can I view your project demos?",
        answer:
            "Absolutely. You can access my project demos through the portfolio site’s project section.",
    },
    {
        question: "Can I try your AI chatbot?",
        answer:
            "Yes! You can click the 'Ask My AI Chatbot' button on the home page to get quick answers about my profession, projects, and more.",
    },
    {
        question: "Do you collaborate on open-source or freelance projects?",
        answer:
            "I’m open to impactful collaborations in AI, data science, or open-source contributions. Feel free to reach out via the contact section if you have something in mind.",
    },
    {
        question: "Do you contribute to the community?",
        answer:
            "Yes. I mentor juniors, write detailed articles, participate in discussions, and support open education by breaking down advanced ML topics in public blogs.",
    },
    {
        question: "What’s your approach to learning and upskilling?",
        answer:
            "I believe in building as I learn — creating functional tools, publishing blogs, and continuously expanding into emerging fields like generative AI, MLOps, and applied ML research.",
    },
    {
        question: "Can I reuse your code or ideas?",
        answer:
            "Yes, for most open-source projects under permissive licenses. Please check individual GitHub repositories for details and attribution guidelines.",
    },
    {
        question: "What’s your long-term goal?",
        answer:
            "To lead the development of AI-driven systems that solve meaningful real-world problems at scale — blending technical innovation with domain expertise.",
    },
    {
        question: "How can I contact you?",
        answer:
            "You can reach me directly via the LinkedIn or email links provided on this site.",
    },
  ];

  return (
    <section id="faq" className="bg-faq min-h-screen scroll-mt-[80px] -mt-[80px]">

        <div className="w-full max-w-1xl px-4 sm:px-6 lg:px-20 pt-2">

            <HashLink
                smooth
                to="/#home"
                className="inline-flex items-center text-sm font-semibold text-gray-800 border border-blue-200 px-3 py-2 rounded-lg hover:bg-blue-50 hover:border-blue-400 hover:shadow-sm transition-all"
            >
                <span className="mr-1">←</span> Go back to Home
            </HashLink>

            <h2 className="text-2xl sm:text-3xl font-bold title-color mb-6 text-center mt-0">
                <u>Frequently Asked Questions (FAQ)</u>
            </h2>

            <div className="space-y-2">
            {faqs.map((faq, index) => (
                <div
                key={index}
                className="bg-white p-3 rounded-xl shadow border border-gray-200 transition hover:shadow-md"
                >
                <h3 className="text-md font-semibold text-gray-800 mb-1">
                    {faq.question}
                </h3>
                <p className="text-md text-gray-700">{faq.answer}</p>
                </div>
            ))}
            </div>
        </div>
        
    </section>
  );
}

export default Faq;
